import { IEnvironment } from './environment.model';

export const environment: IEnvironment = {
  production: true,
  apiUrl: 'https://api.matilda.cloud',
  wsUrl: 'https://api.matilda.cloud/ws',
  googleMapsApiKey: 'AIzaSyBc3nPqjufTCkVa9c50mvyyQDwV3XJ7wIU',
  maxImageSize: 10 * 1024 * 1024,
  recommendedImageSize: 2 * 1024 * 1024,
  experimentalFeatures: {
    deliveryDays: true
  },
  sentryDsn: 'https://6395719bf76d45fb8987e5cbe96b4194@sentry.fastdev.se/33',
  mqtt: 'wss://matilda-prod-read:VC4tnSNPkR5PfVd94Ecne2jjASW2vcb4@b-53d0f4e9-4a36-4a23-b56f-13335a4d6a77-1.mq.eu-central-1.amazonaws.com:61619',
  webUrl: 'https://order.matilda.cloud/'
};
